<template>
  <div>
    <vxe-table
          border="inner"
          keep-source
          highlight-hover-row
          highlight-current-row
          ref="xTablebbbb"
          height="300"
          :data="sxtableData"
          :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}">
          <vxe-column field="sxname" title="上线名称" width="120" sortable :edit-render="{name: '$input', props: {type: 'text'}}">
                <template #edit="{ row }">
                  <vxe-input v-model="row.sxname" type="text"></vxe-input>
                </template>
              </vxe-column>
          <vxe-column
              v-for="config in tableColumn"
              :key="config.key"
              :type="config.type"
              :field="config.field"
              :title="config.title"
              :fixed="config.fixed"
              :width="config.width"
              :filters="config.filters"
              :edit-render="{name: '$input', props: {type: 'number'}}">
            </vxe-column>
        </vxe-table>

      
        <el-button @click="shangxiandata"   type="primary" icon="el-icon-edit">获取上线数据</el-button> 
        <el-button @click="shangxiandatasave"   type="primary" icon="el-icon-edit">保存上线数据</el-button>
        <el-button @click="createsxl"   type="primary" icon="el-icon-edit">生成上线</el-button>
  </div>

   </template>
   
   
   <script>
   import axios from 'axios'
   import qs from 'qs'
   import localStorage from 'localStorage'
   import { VXETable, VxeTableInstance, VxeTablePropTypes } from 'vxe-table'
   export default {
     data() {
       return {
         msg: '',
           // 保存传递过来的index
           myIndex: '',
           img_src:'',
           xm:'',
           xm_id:'',
           sb:'',
           kaohao:'',
           page:'',
           kemucount:0,
           screenWidth: document.body.clientWidth-80,
           imgShowHeight:0,
             imgShowWidth:0,
             allAlign: null,
             tableColumn: [
        { key: 1, type: 'seq', width: 60, fixed: null },
        { key: 2, type: 'checkbox', width: 50, fixed: null },
        { key: 3, field: 'name', title: 'Name', width: 100 },
        { key: 4, field: 'nickname', title: 'Nickname', width: 100 },
        { key: 5, field: 'sex', title: 'Sex', width: 100, filters: [{ value: '1', label: '男' }] },
        { key: 6, field: 'role', title: 'Role', width: 100 },
        { key: 7, field: 'address', title: 'Address', width: 200 }
      ] ,
      sxtableData: [
        { id: 10001, name: 'Test1', nickname: 'T1', role: 'Develop', sex: '1', age: 28, address: 'test abc' },
        { id: 10002, name: 'Test2', nickname: 'T2', role: 'Test', sex: '0', age: 22, address: 'Guangzhou' },
        { id: 10003, name: 'Test3', nickname: 'T3', role: 'PM', sex: '1', age: 32, address: 'Shanghai' },
        { id: 10004, name: 'Test4', nickname: 'T4', role: 'Designer', sex: '0 ', age: 23, address: 'test abc' },
        { id: 10005, name: 'Test5', nickname: 'T5', role: 'Develop', sex: '0 ', age: 30, address: 'Shanghai' },
        { id: 10006, name: 'Test6', nickname: 'T6', role: 'Designer', sex: '0 ', age: 21, address: 'test abc' },
        { id: 10007, name: 'Test7', nickname: 'T7', role: 'Test', sex: '1', age: 29, address: 'test abc' },
        { id: 10008, name: 'Test8', nickname: 'T8', role: 'Develop', sex: '1', age: 35, address: 'test abc' }
      ],
           
       }
     },
    
     activated: function () {
        this.xm_id=localStorage.getItem('xm_id')
        this.xm=localStorage.getItem('xm')  
   
        this.tableColumn=[]
        this.sxtableData=[]
         // this.shangxiantable()
   
       },
       methods: {

        
      createsxl () {              
            console.log('createsxl')   
             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'createsxl'})).then((res)=>{
              console.log(res)
               
              
          }).catch((res)=>{
              console.log(response)
          })

     },

        shangxiandatasave () {              
         
          let updateRecordsx = this.$refs.xTablebbbb.getUpdateRecords()
            console.log(updateRecordsx)

          console.log('shangxiandatasave')   
          
            const $table = this.$refs.xTablebbbb
            const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()     
            const body = { insertRecords, removeRecords, updateRecords }
                      
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'shangxiandatasave','kemucount':this.kemucount,"scsxdata":JSON.stringify(body)})).then((res)=>{
              console.log(res)
               
              
          }).catch((res)=>{
              console.log(response)
          })

     },

        shangxiandata () {              
            console.log('shangxiandata')   
             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'shangxiandata'})).then((res)=>{
              console.log(res)
              this.kemucount=res.data.kemucount
              this.tableColumn=res.data.tableColumn
              this.sxtableData=res.data.tableData
            
               
              
          }).catch((res)=>{
              console.log(response)
          })

     },
       shangxiantable () {              
            
          
       },

   

       }
   }
   
   </script>
   
   <style lang="scss">
   .imgdiv{
          
           display: flex;
           justify-content: center;
           align-items: center;
       }
   </style>